<template>
    <div class="router_panel">
        <div v-if="isTeacher" class="panel_item"
             @click="routerPush('teacherHomepage')"
             :class="{'active': activeRouter('teacherHomepage')}">
            <span class="panel_text">首页</span>
        </div>
        <div v-if="isTeacher" class="panel_item"
             @click="routerPush('myCourses')"
             :class="{'active': activeRouter('teacherClassroomList/myCourses/teacherClassVideo')}">
            <span class="panel_text">我的课程</span>
        </div>
        <div v-if="!isTeacher" class="panel_item"
             @click="routerPush('studentHomepage')"
             :class="{'active': activeRouter('studentHomepage')}">
            <span class="panel_text">首页</span>
        </div>
        <div v-if="!isTeacher" class="panel_item"
             @click="routerPush('digitalClassroom')"
             :class="{'active': activeRouter('digitalClassroom/classroomList') || activeRouter('/mangoStudent/studentClassVideo')}">
            <span class="panel_text">
                <span>课堂</span>
                <span v-if="isLessonUpdated" class="update_status"></span>
            </span>

        </div>
        <div v-if="!isTeacher" class="panel_item"
             @click="routerPush('paperList')"
             :class="{'active': activeRouter('paperList') || $route.query.type === 'homework'}">
            <span class="panel_text">作业</span>
        </div>
        <div v-if="!isTeacher" class="panel_item"
             @click="routerPush('MangoExamList')"
             :class="{'active': activeRouter('MangoExamList') || $route.query.type === 'exam'}">
            <span class="panel_text">考试</span>
        </div>
        <div v-if="!isTeacher" class="panel_item"
             @click="routerPush('personal')"
             :class="{'active': activeRouter('personal')}">
            <span class="panel_text">个性化</span>
        </div>
        <div v-if="!isTeacher" class="panel_item"
             @click="openInformationCenter">
            <span class="panel_text">资料中心</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "routerPanel",
        props: ['isTeacher'],
        data() {
            return {
                isLessonUpdated: false,
            }
        },
        created() {
            if (!this.isTeacher) {
                this.$https.get('/api/conn/coz/selectLessonRedMark').then(response => {
                    if (response['code'] !== 0)
                        return;

                    this.isLessonUpdated = response['data'];
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                });
            }
        },
        methods: {
            activeRouter (name) {
                return name.includes(this.$route.name)
            },
            routerPush (name) {
                if (this.activeRouter(name)) return;
                this.$router.push({name: name})
            },
            openInformationCenter () {
                // 资料中心 type: 2
                this.gotoAuth(2)
            },
            // 免登
            gotoAuth (type) {
                this.$https.get('/api/oauth2/redirectUrl', {
                    params: {
                        type: type
                    }
                }).then((response) => {
                    if (response.code === 0) {
                        window.open(`${response.data}`, '_blank');
                    }
                }).catch((error) => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .router_panel{
        height: 100%;
        display: flex;
        /*width: 230px;*/
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        white-space: nowrap;
        font-family: Alibaba-PuHuiTi-Medium;
        .panel_item{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            cursor: pointer;
            width: 120px;
            .panel_img{
                height: 12px;
                margin-right: 10px;
            }
            .panel_text{
                position: relative;
                font-size:15px;
                font-family:Alibaba-PuHuiTi-Regular;
                font-weight:400;
                /*color:rgba(54,54,58,.66);*/
                color:rgba(54,54,58,.66);
            }
            &:hover{
                .panel_text{
                    color: #2296F3;
                    font-weight: 600;
                }
            }
            &.active{
                /*background:rgba(34,150,243,.04);*/
                /*border-left: 4px solid rgba(34,150,243,1);*/
                /*padding-left: 36px;*/
                .panel_text{
                    color: #2296F3;
                    font-weight: 600;
                }
            }
            .update_status {
                position: absolute;
                top: 0;
                right: -5px;
                width: 6px;
                height: 6px;
                background-color: #FF6466;
                border-radius: 3px;
            }
        }
    }
</style>
